import { Year } from "../components/register/my-tasks/my-tasks.util";
import { IMemberDetail } from "../interfaces/member.interface";
import { MemberProfileDetails } from "../services/member.service";


export function getCurrentFinancialQuarter(){
    const month = new Date().getMonth();
    const index = Math.floor(month / 3);
    return index == 0 ? 4 : index;
}

export function getFinancialYearOptions (numberOfOptions = 2): Year[] {
    const financialYearOptions = [];
    const currentYear = new Date().getFullYear();
    const currentQuarter = getCurrentFinancialQuarter();

    const startYear =  currentYear;
    const firstYearInOption = startYear - numberOfOptions + 1;
    for (let i = startYear; i >= firstYearInOption; --i) {
        const yearString: string = i.toString();
        const lastTwoDigit: string = yearString.slice(2, 4);

        financialYearOptions.push({
            year: +`${yearString}${parseInt(lastTwoDigit) + 1}`,
            yearLabel: `${yearString}-${parseInt(lastTwoDigit) + 1}`
        });
    }
    return financialYearOptions;
}

export function filterOutInActiveMembers(list: IMemberDetail[] | MemberProfileDetails[]) {
    return list.filter((member:any) => member.isActive || member.active);
}